// components/DeleteConfirm.tsx
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import { del } from '../../../hook/request';
import { toast } from 'react-toastify';

type DeleteConfirmProps = {
  url: string;
  trigger?: React.ReactNode;
  onError?: (err: unknown) => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  triggerClassName?: string;
  onSuccess?: () => void;
};

const DeleteConfirm: React.FC<DeleteConfirmProps> = ({
  url,
  trigger,
  onSuccess,
  onError,
  title = 'Conferma eliminazione',
  message = 'Sei sicuro di voler eliminare?',
  confirmText = 'Elimina',
  cancelText = 'Annulla',
  triggerClassName = 'btn btn-sm btn-outline-danger',
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = () => setOpen(v => !v);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await del<any>(url);
      toast.success('Eliminato con successo');
      setOpen(false);
      onSuccess?.();
    } catch (err) {
      toast.error('Errore durante l’eliminazione');
      onError?.(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {trigger ? (
        <span onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
          {trigger}
        </span>
      ) : (
        <button type="button" className={triggerClassName} onClick={() => setOpen(true)}>
          <i className="fa-solid fa-trash me-1" />
          Elimina
        </button>
      )}

      <Modal isOpen={open} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <Button color="light"  style={{color:'black'}} onClick={toggle} disabled={loading}>
            {cancelText}
          </Button>
          <Button color="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? <Spinner size="sm" /> : confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DeleteConfirm;
